export const CU_BU_LEADER_ACCESS = 'bu_leader';

export const CU_EXTERNAL_STAFF_ACCESS = 'external_staff';

export const CU_STAFF_ACCESS = 'staff';

export const changeUnitAccessesOptions = [
  {
    text: 'BU Leader',
    value: CU_BU_LEADER_ACCESS,
    selected: true,
  },
  {
    text: 'Staff',
    value: CU_STAFF_ACCESS,
  },
  {
    text: 'External Staff',
    value: CU_EXTERNAL_STAFF_ACCESS,
  },
];



// WEBPACK FOOTER //
// ./src/constants/changeUnitsAccesses.js